/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Jan 2022
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import PopupHeader from '../../../../components/PopupHeader';
import Button from '../../../../components/Button';
import classes from './CubbyMenu.module.css';

const CubbyMenu = ({ onClose, onCubbyMenuPress, slotName }) => {
  const buttonConfig = [
    { name: `Move from ${slotName}`, key: 'moveFromSlot' },
    { name: `Clear from ${slotName}`, key: 'clearFromSlot' },
    { name: 'Picked Up', key: 'pickedUp' },
  ];

  return (
    <div className={classes.container}>
      <PopupHeader onClose={onClose} />
      <div className={classes.bodyWrapper}>
        {buttonConfig.map(op =>
          <Button key={op.key} onClick={() => onCubbyMenuPress(op.key)} className={classes.button}>
            <span className={classes.buttonText}>{op.name}</span>
          </Button>
        )}
      </div>
    </div>
  );
};

export default CubbyMenu;

CubbyMenu.propTypes = {
  onClose: PropTypes.func,
  onCubbyMenuPress: PropTypes.func,
  slotName: PropTypes.string,
};

CubbyMenu.defaultProps = {
  onClose: () => { },
  onCubbyMenuPress: () => { },
  slotName: '',
};
